import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import chinese from './localization/ch.json'

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        keySeparator: false,
        fallbackLng: 'en',
        saveMissing: true,
        resources: {
            ch: {
                chinese: chinese
            },
        },
    })
export default i18n;